import privacy from './en-US/privacy'
import user from './en-US/user'
import login from './en-US/login'
import admin from './en-US/admin'

export default {
  ...privacy,
  ...user,
  ...login,
  ...admin,
}
